import { styled } from '@moonpig/launchpad-utils'
import React from 'react'
import { Box, Flex, LoadingIndicator } from '@moonpig/launchpad-components'

const SpinnerOverlay = styled(Box)`
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
  background-color: #fff;
  opacity: 0.7;
  z-index: 2040;
`

export const LoadingOverlay: React.FC<{ label: string }> = ({ label }) => (
  <SpinnerOverlay>
    <Box height={1}>
      <Flex
        width="100%"
        height="100%"
        justifyContent="center"
        alignItems="center"
        data-testid="loading-overlay"
      >
        <LoadingIndicator label={label} />
      </Flex>
    </Box>
  </SpinnerOverlay>
)
